/**
  this class needs to be in separate file because of sass bug:
  https://github.com/sass/libsass/issues/3061
 */
._sectionHeaderNoDivider_nkk8l_5 {
  margin-top: min(1.9vh, 18px);
}
